import React from "react";
import {
  AHIcon,
  AHSeparator,
  Box,
  Circle,
  ListItem,
  SectionHeader,
} from "arkh";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { SelectListItem } from "arkh/src/cross-platform/SelectList/SelectListItem";
import { NumberGoal } from "../NumberGoal";
import { Goal } from "../../State/Routine/types";

export const TaskNumberResponseOptions = ({
  unit,
  setUnit,
  setGoal,
  goal,
  goalValue,
  setGoalValue,
}: {
  unit: "CURRENCY" | "CUSTOM";
  setUnit: (unit: "CURRENCY" | "CUSTOM") => void;
  goal?: Goal | undefined;
  setGoal: (goal?: Goal) => void;
  goalValue?: number;
  setGoalValue?(_: number): void;
}) => {
  const intl_tokens = useIntlTokens();
  const onPressCustom = React.useCallback(() => {
    setUnit("CUSTOM");
  }, [setUnit]);
  const onPressCurrency = React.useCallback(() => {
    setUnit("CURRENCY");
  }, [setUnit]);

  return (
    <>
      <SectionHeader>
        <SectionHeader.Title>{intl_tokens.Unit}</SectionHeader.Title>
      </SectionHeader>
      <Box space="medium">
        <UnitOption
          onPress={onPressCustom}
          selected={unit === "CUSTOM"}
          isFirst
          title={intl_tokens.Other}
          icon={<AHIcon type="other" />}
        />
        <AHSeparator />
        <UnitOption
          isLast
          onPress={onPressCurrency}
          selected={unit === "CURRENCY"}
          title={intl_tokens.Currency}
          icon={<AHIcon type="currency" />}
        />

        <NumberGoal
          setGoalDirection={setGoal}
          goalDirection={goal}
          goalValue={goalValue}
          setGoalValue={setGoalValue}
        />
      </Box>
    </>
  );
};

export const UnitOption = (props: {
  isFirst?: boolean;
  isLast?: boolean;
  selected?: boolean;
  title: React.ReactNode;
  icon: React.ReactNode;
  onPress: () => void;
}) => {
  return (
    <SelectListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={props.onPress}
      selected={!!props.selected}
      border={"border-primary"}
      left={<Circle size="smallMedium">{props.icon}</Circle>}
    >
      <ListItem.Title>{props.title}</ListItem.Title>
    </SelectListItem>
  );
};
